export default {
  THP: /^[A-Z]{1}[A-Z]{1}[0-9]{9}TH$/,
  ECP: /^OF[0-9]{9}TH$/,
  TP2: /^R[A-Z]{1}[0-9]{9}TH$/,
  EMST: /^[A-Z]{1}[A-Z]{1}[0-9]{9}TH$/,
  EMSW: /^[A-Z]{1}[A-Z]{1}[0-9]{9}TH$/,
  EMSX: /^[A-Z]{1}[A-Z]{1}[0-9]{9}TH$/,
  EMSXP: /^[A-Z]{1}[A-Z]{1}[0-9]{9}TH$/,
};
